import { IPatientPharmacyRelation } from '@pia/pia.shared';

export class PatientPharmacyRelationViewModel implements IPatientPharmacyRelation {
  subunitId: string;
  contactId: string;
  _id: string;
  timestamp: Date;
  archived: boolean;
}
